import request from '@/utils/request'

/**
 * 卡密列表查询
 * POST /kami/card/list
 */
export function getCardList(data) {
  return request({
    url: '/kami/card/list',
    method: 'post',
    data
  })
}

/**
 * 新增卡密
 * POST /kami/card/addCard
 */
export function addCard(data) {
  return request({
    url: '/kami/card/addCard',
    method: 'post',
    data
  })
}

/**
 * 修改卡密
 * PUT /kami/card/updateCard
 */
export function updateCard(data) {
  return request({
    url: '/kami/card/updateCard',
    method: 'put',
    data
  })
}

/**
 * 批量导入卡密
 * POST /kami/card/importCard
 */
export function importCard(formData) {
  return request({
    url: '/kami/card/importCard',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

/**
 * 删除卡密（支持单个/批量）
 * POST /kami/card/delCard
 * body: [id, ...]
 */
export function delCard(ids) {
  return request({
    url: '/kami/card/delCard',
    method: 'post',
    data: ids
  })
}

/**
 * 获取卡密详情
 * GET /kami/card/getCardDetail/{cardId}
 */
export function getCardDetail(cardId) {
  return request({
    url: `/kami/card/getCardDetail?cardId=${cardId}`,
    method: 'get'
  })
}

/**
 * 单客户核销发放
 * POST /kami/card/redeemByOneOwner
 * body: { cardIdList, ownerId, templateId }
 */
export function redeemByOneOwner(data) {
  return request({
    url: '/kami/card/redeemByOneOwner',
    method: 'post',
    data
  })
}
